import React, { useRef, useEffect } from "react";
import { Collaps, Expand } from "../icons";

interface AccordionItemProps {
    header: string;
    text: React.ReactNode;
    id: number;
    activeId: number | null;
    handleToggle: (id: number) => void;
    key?: React.Key;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ header, text, id, activeId, handleToggle }) => {
    const contentEl = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentEl.current) {
            contentEl.current.style.maxHeight = activeId === id ? `${contentEl.current.scrollHeight}px` : '0px';
        }
    }, [activeId, id]);

    return (
        <div className="accordion-card">
            <div className="accordion-header">
                <div className={`accordion-toggle ${activeId === id ? 'active' : ''}`} onClick={() => handleToggle(id)}>
                    <h5 className="accordion-title">{header}</h5>
                    {activeId === id ? <Collaps /> : <Expand />}
                </div>
            </div>
            <div
                ref={contentEl}
                className={`faq-collapse ${activeId === id ? 'show' : ''}`}
            >
                <div className="accordion-body">
                    {text}
                </div>
            </div>
        </div>
    );
};

export default AccordionItem;
